import {AutogenLayoutRateIndexControlMainPanel} from "./autogen/AutogenLayoutRateIndexControlMainPanel";

export class RateIndexControlMainPanel extends AutogenLayoutRateIndexControlMainPanel{

    async onLoad() {

    }


}
